<panel width="600">
  <menu always-visible>
    <menuitem (click)="showSystemLog()" icon="file-alt">{{ 'company.accounting-plans.show-log' | translate }}</menuitem>
    <menuitem *requiredCredential="credentialTypeEnum.EditAccountingPlan; and: !isSuspended()" (click)="changeProductPlanName()" icon="pen-to-square">{{ 'company.product-plans.context-menu.change-name' | translate }}</menuitem>
    <menuitem *requiredCredential="credentialTypeEnum.EditAccountingPlan; and: isSuspended()" (click)="resumeRegistrations()" icon="hand-holding-dollar">{{ 'company.accounting-plans.resume' | translate }}</menuitem>
    <menuitem *requiredCredential="credentialTypeEnum.CreateProductPlanManually; and: isDeletable()" (click)="deleteAccountingPlan()" icon="trash-alt">{{ 'company.product-plans.delete' | translate }}</menuitem>
    <menuitem *requiredCredential="credentialTypeEnum.EditAccountingPlan; and: !isSuspended() && accountingPlan!.ignorePriceAdjustments" (click)="setIgnorePriceAdjustment(false)" icon="chart-pie-simple-circle-dollar">{{ 'company.accounting-plans.context-menu.resume-price-adjustment' | translate }}</menuitem>
    <menuitem *requiredCredential="credentialTypeEnum.EditAccountingPlan; and: !isSuspended() && !accountingPlan!.ignorePriceAdjustments" (click)="setIgnorePriceAdjustment(true)" icon="chart-pie-simple-circle-dollar">{{ 'company.accounting-plans.context-menu.suspend-price-adjustment' | translate }}</menuitem>
    <menuitem *requiredCredential="credentialTypeEnum.EditAccountingPlanEndDate; and: isActive() && productPlan.autoRenewable && !isSuspended()" (click)="changeEndDate()" icon="calendar-day">{{ 'company.accounting-plans.context-menu.change-end-date' | translate }}</menuitem>
    <menuitem *requiredCredential="credentialTypeEnum.EditProductPlanTerminationNoticePeriod; and: isActive() && productPlan.autoRenewable && !isSuspended()" (click)="changeTerminationNoticePeriod()" icon="calendar-exclamation">{{ 'company.product-plans.context-menu.change-termination-notice-period' | translate }}</menuitem>
    <menuitem *requiredCredential="credentialTypeEnum.EditProductPlanParent" (click)="selectParentPlan()" icon="stream">{{ 'company.product-plans.context-menu.select-parent' | translate }}</menuitem>
  </menu>
  <h1>{{ productPlan | productName }}</h1>

  <list-view [selectable]="false" emptyLabel="">
    @for (replacedPlan of replacementsOldPlans; track replacedPlan) {
      <list-item info statusIcon="angle-double-up" [clickable]="true" (action)="selectProductPlan(replacedPlan.id!)">
        {{ 'company.product-plans.supersedes-plan' | translate }}: <a>{{ replacedPlan | productName }}</a>
      </list-item>
    }
    @for (replacingPlan of replacementsNewPlans; track replacingPlan) {
      <list-item info statusIcon="angle-double-up" [clickable]="true" (action)="selectProductPlan(replacingPlan.id!)">
        {{ 'company.product-plans.superseded-by-plan' | translate }}: <a>{{ replacingPlan | productName }}</a>
      </list-item>
    }

    @if (!settlementInfo?.activeSettlement && accountingPlan && accountingPlan.suspended) {
      <list-item alert statusIcon="hand-holding-dollar">
        {{ 'company.accounting-plans.is-suspended' | translate }}
        {{ accountingPlan.suspended | customDate: 'shortDate' }}
      </list-item>
    }
    @if (planIsInSettlement()) {
      <list-item alert statusIcon="chart-pie-simple-circle-dollar" [clickable]="true" (action)="openSettlement()">
        {{ 'company.accounting-plans.is-part-of-settlement' | translate }} <a>{{ 'company.accounting-plans.settlement-link' | translate: { referenceNumber: settlementInfo?.activeSettlement?.referenceNumber } }}</a>
      </list-item>
    }
    @if (planIsInDebtCollection()) {
      <list-item alert statusIcon="exclamation-triangle">
        {{ 'company.accounting-plans.is-part-of-debt-collection' | translate }}
      </list-item>
    }

    @if (accountingPlan?.ignorePriceAdjustments) {
      <list-item warning statusIcon="chart-pie-simple-circle-dollar">
        {{ 'company.accounting-plans.ignores-price-adjustments' | translate }}
      </list-item>
    }
    @if (productPlan.transferPlans!.length > 0) {
      <list-item info statusIcon="download" [clickable]="true" (action)="downloadTransferDeclaration()">
        {{ 'company.product-plans.was-transferred' | translate }} (<a>{{ 'company.product-plans.transfer-declaration' | translate }}</a>)
      </list-item>
    }
  </list-view>

  @if (!accountingPlan) {
    <skeletons [customSkeletons]="[['5em', '100%', 'col-6'], ['5em', '100%', 'col-6']]" class="row" />
    <skeletons [customSkeletons]="[['2em', '100%', 'col-6'], ['2em', '100%', 'col-6']]" class="row" />
    <skeletons [customSkeletons]="[['2em', '100%', 'col-6'], ['2em', '100%', 'col-6']]" class="row" />
  }
  @else {    
    <accounting-plan [productPlan]="productPlan" [accountingPlan]="accountingPlan" [accountingPlans]="productPlan.accountingPlans" />
    <h3>{{ 'company.product-plans.accounting-plans' | translate }}</h3>
    <list-view>
      <header [sortColumn]="false">{{ 'company.accounting-plans.id' | translate }}</header>
      <header defaultSort="descending">{{ 'company.accounting-plans.start-date' | translate }}</header>
      <header>{{ 'company.accounting-plans.end-date' | translate }}</header>
      <header align-right>{{ 'company.accounting-plans.total-value' | translate }}</header>
      <row *listData="let plan from productPlan.accountingPlans" [statusColor]="accountingService.statusColor(productPlan, plan)" statusTitle="{{ accountingService.statusTitle(productPlan, plan) | translate }}" [attr.data-id]="plan.id" [highlighted]="accountingPlan && accountingPlan.id == plan.id" (action)="selectAccountingPlan(plan);">
        <column>{{ plan.id.substring(0,8) }}</column>
        <column [sortValue]="plan.startDate ?? infinity">{{ plan.startDate | customDate: 'shortDate' }}</column>
        <column [sortValue]="plan.endDate ?? infinity">{{ plan.endDate | customDate: 'shortDate' }}</column>
        <column align-right [sortValue]="plan.totalPlanValue">{{ plan.totalPlanValue | currency }}</column>
      </row>
    </list-view>
  }
</panel>
